"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBundlePromoValue = void 0;
var currency_js_1 = __importDefault(require("currency.js"));
var promoValue_1 = require("./promoValue");
var promoTypeIsPercentage_1 = require("./promoTypeIsPercentage");
var promoMaxAmount_1 = require("./promoMaxAmount");
var getBundlePromoValue = function (price, promotion) {
    var promotionValue = (0, promoValue_1.promoValue)(promotion);
    if ((0, promoTypeIsPercentage_1.promoTypeIsPercentage)(promotion)) {
        var promotionFixedValue = (0, currency_js_1.default)(promotionValue).multiply(price).divide(100).value;
        var promotionMaxAmount = (0, promoMaxAmount_1.promoMaxAmount)(promotion);
        if (promotionMaxAmount > 0) {
            return Math.min(price, promotionFixedValue, promotionMaxAmount);
        }
        return Math.min(price, promotionFixedValue);
    }
    return Math.min(price, promotionValue);
};
exports.getBundlePromoValue = getBundlePromoValue;
